$('.ct2-slides').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        arrows: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        arrows: false
      }
    }
  ]
});
$('.custom-vid-tes-slider').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 9000,
  arrows: false,
  dots: true,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$(function() {
  var waitForEl = setInterval(function() {

    if($('div#shopify-block-loox_reviews_loox_rating_nNiac4 a').length > 0){
        $('div#shopify-block-loox_reviews_loox_rating_nNiac4 a').attr('href','#shopify-section-template--23583004229917__17279255591294394a');
        
        clearInterval(waitForEl);
      
    }

  }, 10);
  
  $(".button").each(function() {
    if ($(this).attr("href") && $(this).attr("href").includes("wholesale")) {
      $(this).addClass("for-wholesale");
    }
  });
  
});

const video = document.querySelectorAll('.ios-controls');
video.setAttribute('playsinline', '');
video.muted = true; // Required for autoplay on mobile
video.play();

document.addEventListener('DOMContentLoaded', function () {
  var videoElements = document.querySelectorAll('.ios-controls');

  videoElements.forEach(function(videoElement) {
    videoElement.controls = false;

    videoElement.addEventListener('play', function () {
      this.controls = false;
    });

    videoElement.addEventListener('pause', function () {
      this.controls = false;
    });
  });
});